import React from "react";
import { useSelector } from "react-redux";
import { Group, Menu, ActionIcon } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

export default function InteractiveOptions({
  canShowMyResponses,
  canShowPrivate,
  canShowAllResponses,
  showMyResponses,
  setShowMyResponses,
  showPrivate,
  setShowPrivate,
  hideAllMessages,
  setHideAllMessages
}) {
  const { t } = useTranslation();

  const colors = useSelector(state => state.colors);

  const [opened, handlers] = useDisclosure(false);

  const onClickShowMy = () => {
    if (typeof setShowMyResponses === "function") {
      setShowMyResponses(!showMyResponses);
    }
  };

  const onClickShowPrivate = () => {
    if (typeof setShowPrivate === "function") {
      setShowPrivate(!showPrivate);
    }
  };

  const onClickShowAll = () => {
    if (typeof setHideAllMessages === "function") {
      setHideAllMessages(!hideAllMessages);
    }
  };

  if (!canShowMyResponses && !canShowPrivate && !canShowAllResponses) {
    return null;
  }

  return (
    <Group spacing={2}>
      <Menu
        opened={opened}
        onOpen={handlers.open}
        onClose={handlers.close}
        placement="end"
        control={
          <ActionIcon
            variant="transparent"
            onClick={() => {
              if (opened) {
                handlers.close();
              } else {
                handlers.open();
              }
            }}
          >
            <FontAwesomeIcon size="lg" icon={solid("list-check")} color={colors?.default_text_color} />
          </ActionIcon>
        }
      >
        {!!canShowMyResponses && (
          <Menu.Item onClick={onClickShowMy}>
            {showMyResponses ?
              t("tiptap.components.interactiveInput.hideMyResponses")
              : t("tiptap.components.interactiveInput.showMyResponses")}
          </Menu.Item>
        )}
        {!!canShowPrivate && (
          <Menu.Item onClick={onClickShowPrivate}>
            {t(`tiptap.components.interactiveInput.${showPrivate ? "hidePrivateMessages" : "showPrivateMessages"}`)}
          </Menu.Item>
        )}
        {!!canShowAllResponses && (
          <Menu.Item onClick={onClickShowAll}>
            {t(`tiptap.components.interactiveInput.${hideAllMessages ? "showResponses2" : "hideResponses2"}`)}
          </Menu.Item>
        )}
      </Menu>
    </Group>
  );
};